import { wrapThemeProvider } from './helpers/testHelpers';
import { createMediaQueries } from './helpers/mediaQueries';

const utils = {
  wrapThemeProvider,
  createMediaQueries
};
export default utils;
